/* Complete the look: one-click add from the cart drawer. Delegated so it survives drawer re-renders. */
(function () {
  if (window.__coandmiCompleteLook) return;
  window.__coandmiCompleteLook = true;

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.cart-drawer__look-add') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    var productUrl = btn.getAttribute('data-product-url');
    var drawer = document.querySelector('cart-drawer');
    if (!variantId || !drawer || typeof drawer.renderContents !== 'function') {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add').replace(/\.js$/, '') + '.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        if (!res.ok || !res.data || !res.data.sections) throw new Error('add failed');
        drawer.renderContents(res.data);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        if (productUrl) window.location.href = productUrl;
      });
  });
})();
